import React from 'react';
import Pagination from "react-js-pagination";

export default function PaginatingWithInfo(props) {
  let {innerClass, itemClass, linkClass, outerClass, infoClass, ...restOfProps} = props;
  innerClass = (innerClass || '') + ' pagination mt-3';
  itemClass = (itemClass || '') + ' page-item';
  linkClass = (linkClass || '') + ' page-link';
  const showedFrom = ( props.activePage - 1 ) * props.itemsCountPerPage;
  let showedTill = props.activePage * props.itemsCountPerPage;
  if (showedTill > props.totalItemsCount ) showedTill = props.totalItemsCount;
  outerClass = (outerClass || '') + ' row';
  return (
    <div className={outerClass}>
      <div className={infoClass}>
        {showedFrom} - {showedTill} из {props.totalItemsCount}
      </div>
      <Pagination
        innerClass={innerClass}
        itemClass={itemClass}
        linkClass={linkClass}
        {...restOfProps}
      />
    </div>
  );
}